<template>
    <div class="mb-8">
        <slot></slot>
    </div>
</template>